import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  january_rate: {
    name: 'January'
  },
  february_rate: {
    name: 'February'
  },
  march_rate: {
    name: 'March'
  },
  april_rate: {
    name: 'April'
  },
  may_rate: {
    name: 'May'
  },
  june_rate: {
    name: 'June'
  },
  july_rate: {
    name: 'July'
  },
  august_rate: {
    name: 'August'
  },
  september_rate: {
    name: 'September'
  },
  october_rate: {
    name: 'October'
  },
  november_rate: {
    name: 'November'
  },
  december_rate: {
    name: 'December'
  }
};

const _tables = [
  {
    name: 'Number of subscriptions',
    order: 255,
    columnLables,
    key: 'SUBSCRIPTION',
    dataIndex: 3
  },
  {
    name: 'Number of redemptions',
    order: 267,
    columnLables,
    key: 'REDEMPTION',
    dataIndex: 4
  }
];

export function HistoricalProfile2({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.HISTORICAL_PROFILE,
    onChangeFund,
    schema: schema.HISTORICAL_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HISTORICAL_PROFILE?.field_names || [],
    tableName: 'HISTORICAL_PROFILE',
    tables: _tables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="reporttables-historical-profile-2-group">
      {tables.map((rows, index) => (
        <Table
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          key={index + 'HISTORICAL_PROFILE'}
          id={`reporttables-historical-profile-2-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
        />
      ))}
    </StyledTables>
  );
}
